import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { PainSiteService } from "../pain-site-card/pain-site.service";
import { NewWoundData, PreviousWound } from "./new-wound-site-service";

@Injectable()
export class NewWoundService {
  painService: PainSiteService;
  allDataObservable: BehaviorSubject<NewWoundData[]> = new BehaviorSubject([]);
  currentPointData: BehaviorSubject<NewWoundData> = new BehaviorSubject(null);
  previousWoundStatus: PreviousWound;

  getPainService(): PainSiteService {
    return this.painService;
  }

  setPainService(painSiteService: PainSiteService): void {
    this.painService = painSiteService;
  }

  getAllDataObservable(): Observable<NewWoundData[]> {
    return this.allDataObservable.asObservable();
  }

  setAllDataObservable(data): void {
    this.allDataObservable.next(data);
  }

  setCurrentPointData(newWoundData: NewWoundData) {
    if (newWoundData) {
      this.currentPointData.next(newWoundData);
    }
  }

  getCurrentPointData(): Observable<NewWoundData> {
    return this.currentPointData.asObservable();
  }

  updateOrPushCurrentPoint(data): void {
    let index = data["locationIndex"];
    if (data) {
      let array = this.getAllPointData();
      for (let i in array) {
        if (array[i].locationIndex === index) {
          array[i] = data;
        }
      }
    }
  }

  pushTheCurrentDataToArr(data) {
    if (data) {
      if (this.getAllPointData() && this.getAllPointData().length > 0) {
        this.getAllPointData().push(data);
      } else {
        let newWoundArr = [];
        newWoundArr.push(data);
        this.setAllDataObservable(newWoundArr);
      }
    }
  }

  private getAllPointData(): NewWoundData[] {
    return this.allDataObservable.getValue();
  }

  getPointDataByIndex(index: number): NewWoundData {
    return this.getAllPointData().find(
      (item) => item && item.locationIndex === index
    );
  }

  removeLastPoint(): void {
    this.getAllPointData().pop();
  }

  setPreviousWoundStatus(previousWound: PreviousWound): void {
    this.previousWoundStatus = previousWound;
  }

  getPreviousWoundStatus(): PreviousWound {
    return this.previousWoundStatus;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/new-wound-site-card/new-wound.service.ts